var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '../../Typography';
import { TucarTheme } from '../../theme';
import { getWeekDayIndex, compareTwoDates } from '../utils';
import { DateSlotStyled, SelectedDateSlotStyled } from './styled';
const DateSlot = (_a) => {
    var props = __rest(_a, []);
    const { disabled, multipleMode, label, onClick, style, selected, value } = props, rest = __rest(props, ["disabled", "multipleMode", "label", "onClick", "style", "selected", "value"]);
    const isToday = value ? compareTwoDates(value, new Date(), 'equal') : false;
    const isSideLimit = () => {
        if (value && getWeekDayIndex(value) === 0)
            return 'left';
        if (value && getWeekDayIndex(value) === 6)
            return 'right';
        return undefined;
    };
    const handleClick = (event) => {
        if (disabled)
            return;
        onClick(event);
    };
    const getSlotColor = () => {
        if (disabled)
            return TucarTheme.colors.gray600;
        if (isToday && !selected)
            return TucarTheme.colors.gray100;
        if (selected)
            return TucarTheme.colors.blue500;
        return TucarTheme.colors.gray800;
    };
    const renderLabel = () => (_jsx(Typography, Object.assign({ color: getSlotColor(), weight: selected ? 'bold' : 'medium', align: "center", style: { fontSize: '14px', lineHeight: '120%' } }, { children: label })));
    return (_jsx(DateSlotStyled, Object.assign({ multipleMode: multipleMode, disabled: disabled, onClick: handleClick, selected: selected, style: style, isSideLimit: isSideLimit() }, Object.assign(Object.assign(Object.assign(Object.assign({}, (multipleMode ? { 'data-multiple-mode': true } : {})), (disabled ? { 'data-disabled': true } : {})), (selected ? { 'data-selected': true } : {})), (isToday ? { 'data-is-today': true } : {})), rest, { children: selected || isToday ? (_jsx(SelectedDateSlotStyled, Object.assign({ selected: selected, isToday: isToday }, { children: renderLabel() }))) : (renderLabel()) })));
};
export default DateSlot;
//# sourceMappingURL=index.js.map